<div [innerHTML]="info" style=" margin-left: 15px;"></div>
